import React, { useState } from 'react';
import RevxFlexLayout from 'components/RevxFlexLayout';
import { NameBadge } from 'features/Workspace/components/NameBadge';
import { Button, Form, Input } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import classNames from 'classnames';
import { EMAIL_MAXLENGTH, LAST_NAME_MAXLENGTH } from 'utils/constants';
import { RevxButton } from 'components/RevxButton';
import workspaceService from 'services/jobService';
import { JobAdjustmentViewer } from 'domains/workspaceDomain';
import { useMount } from 'ahooks';
import './shareQuote.less';

type Props = {
  data: JobAdjustmentViewer;
};

const ShareQuote = ({
  data: { jobId, jobAdjustmentId, sharedWiths },
}: Props) => {
  const [nameBadgeList, setNameBadgeList] = useState<string[]>([]);
  const [showShareQuoteModal, setShowShareQuoteModal] =
    useState<boolean>(false);
  const [sendQuoteLoading, setSendQuoteLoading] = useState<boolean>(false);
  const [shareQuoteFormErrorList, setShareQuoteFormErrorList] = useState<
    string[]
  >([]);
  const [shareQuoteForm] = Form.useForm();
  useMount(() => {
    const list = sharedWiths.map(({ firstName, lastName }) => {
      return `${firstName} ${lastName}`;
    });
    setNameBadgeList(list);
  });
  const sendShareQuoteHandler = () => {
    formErrorFinder();
    shareQuoteForm
      .validateFields()
      .then(async ({ email, firstName, lastName }) => {
        setSendQuoteLoading(true);
        try {
          await workspaceService.jobAdjustmentShareQuote(
            jobId,
            jobAdjustmentId,
            {
              email,
              firstName,
              lastName,
            }
          );
          setNameBadgeList([...nameBadgeList, ...[`${firstName} ${lastName}`]]);
        } finally {
          setSendQuoteLoading(false);
          setShowShareQuoteModal(false);
          shareQuoteForm.resetFields();
        }
      });
  };
  const formErrorFinder = () => {
    shareQuoteForm
      .validateFields()
      .then((r) => {
        setShareQuoteFormErrorList([]);
      })
      .catch((err) => {
        setShareQuoteFormErrorList(
          err.errorFields.filter(({ name }: { name: string[] }) => {
            return name.join().toLowerCase().indexOf('name') > 0;
          })
        );
      });
  };
  return (
    <RevxFlexLayout className="share-quote-wrap">
      <RevxFlexLayout justify="justify-center">
        <span className="label">Shared With</span>
        <div className="name-badge-wrap">
          {nameBadgeList.map((i, k) => (
            <NameBadge name={i} key={k} />
          ))}
        </div>
        <Button
          className="share"
          shape="round"
          onClick={() => {
            setShowShareQuoteModal(!showShareQuoteModal);
          }}
        >
          <PlusOutlined />
          Share
        </Button>
      </RevxFlexLayout>
      <RevxFlexLayout>
        {showShareQuoteModal && (
          <div className="share-quote-modal">
            <Form form={shareQuoteForm} onValuesChange={formErrorFinder}>
              <RevxFlexLayout className="form-wrap">
                <RevxFlexLayout
                  className={classNames('name-input ant-input', {
                    'quote-item-error': shareQuoteFormErrorList?.length > 0,
                  })}
                >
                  <Form.Item
                    name="firstName"
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                  >
                    <Input
                      maxLength={LAST_NAME_MAXLENGTH}
                      placeholder="First Name"
                    />
                  </Form.Item>
                  <Form.Item
                    name="lastName"
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                  >
                    <Input
                      maxLength={LAST_NAME_MAXLENGTH}
                      placeholder="Last Name"
                    />
                  </Form.Item>
                </RevxFlexLayout>
                <RevxFlexLayout className="email-input">
                  <Form.Item
                    name="email"
                    rules={[
                      {
                        required: true,
                      },
                      {
                        type: 'email',
                        message: 'Please enter valid Email',
                      },
                    ]}
                  >
                    <Input maxLength={EMAIL_MAXLENGTH} placeholder="Email" />
                  </Form.Item>
                </RevxFlexLayout>
              </RevxFlexLayout>
            </Form>
            <RevxFlexLayout justify="justify-end">
              <RevxButton
                loading={sendQuoteLoading}
                className="send-btn"
                type="primary"
                onClick={sendShareQuoteHandler}
              >
                SEND
              </RevxButton>
            </RevxFlexLayout>
          </div>
        )}
      </RevxFlexLayout>
    </RevxFlexLayout>
  );
};

export default ShareQuote;
